import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

Vue.use(VueI18n);

// Create a VueI18n instance initially with default settings
const userLocale = window.Laravel?.localization ?? 'en';
const i18n = new VueI18n({
    locale: userLocale,  // Start with 'nl' or another default locale
    fallbackLocale: userLocale,  // Use 'en' or another locale as fallback
    messages: {},  // Start with an empty messages object
    missing: (locale, key, vm) => {
        if(window.Laravel.environment === 'local') {
            setTimeout(async () => {
                if (!i18n.te(key, locale)) {  // Recheck if the key is still missing after 2 seconds
                    console.warn(`Translation missing for ${locale}: ${key} after delay`);
                }
            }, 2000); // Wait for 2 seconds before rechecking
        }
    }
});

// Function to asynchronously load locale messages
async function loadLocaleMessages() {
    try {
        const response = await axios.get(`/translations_i18n/${userLocale}`);
        i18n.setLocaleMessage(userLocale, response.data[userLocale] || {});
    } catch (error) {
        console.error('Failed to load translations:', error);
    }
}

// Load and set the locale messages after creating the i18n instance
loadLocaleMessages();

export default i18n;
